import React from 'react';

const Privacy = () => (
  <div style={{ padding: '0 15px' }}>
    <p>
      Der Schutz Ihrer persönlichen Daten ist uns ein ernstes Anliegen. In den nachfolgenden
      Abschnitten geben wir Ihnen ausführlich Auskunft, welche Daten wir erheben und zu welchem
      Zweck wir diese verwenden.
    </p>
    <p>
      <b>Standortdaten</b>
      <br />
      Durch das Hinzufügen Ihrer persönlichen Orte und der Auswahl weiterer Einstellungen wird auf
      die Ortungsdienste Ihres Smartphones zugegriffen. Diese Erfassung dient nur dem Zweck, Sie für
      die ausgewählten Orte und gewünschten Themenbereiche in Bedarfsfall zu informieren. Dabei
      werden keine personenbezogenen Daten erhoben oder gespeichert. Mit der Deinstallation der App
      werden alle gespeicherten Daten gelöscht.
    </p>
    <p>
      <b>Übermittlung der Daten an Dritte</b>
      <br />
      Eine Weitergabe von Daten an Dritte wird zu keinem Zeitpunkt vorgenommen.
    </p>
    <p>
      <b>Fragen zum Datenschutz</b>
      <br />
      Haben Sie noch Fragen zum Thema Datenschutz? Dann wenden Sie sich gerne an uns. <br />
      <br />
      Marktplatz GmbH - Agentur für Web & App <br />
      Geschäftsführer Frank Dalock <br />
      Stresemannstraße 6 <br />
      21335 Lüneburg <br />
      Tel.: <a href="tel:041317899000">04131 789900-0</a>
      <br />
      Fax: <a href="tel:041317899009">04131 789900-9</a>
      <br />
      E-Mail: <a href="mailto:info@marktplatz-agentur.de">info@marktplatz-agentur.de</a> <br />
      Internet: <a href="http://www.marktplatz-agentur.de">www.marktplatz-agentur.de</a>
    </p>
  </div>
);

export default Privacy;



// WEBPACK FOOTER //
// ./src/js/routes/Information/Privacy.js